import React from 'react';
import styled from 'App/styled';
import ToolTip from '@nykaa/delivery-desktop/components/ToolTip';
import GenuineProductIcon from './genuineProduct';


interface GenuineProductProps {
  genuineProductText: string;
}
interface GenuineProductStyleProps {
  contentClass: string;
}
const ReturnText = styled.div`
  display: flex;
  margin-right: ${({ theme }) => theme.spacing.spacing120};
  cursor: pointer;
  @media (min-width: 768px) and (max-width: 1024px) {
    margin-right: ${({ theme }) => theme.spacing.spacing60};
  }

  &:nth-last-of-type(2) {
    margin-right: ${({ theme }) => theme.spacing.spacing120};

    @media (min-width: 768px) and (max-width: 1024px) {
      margin-right: ${({ theme }) => theme.spacing.spacing60};
    }
  }
  &:hover {
    .${({ contentClass }: GenuineProductStyleProps) => contentClass} {
      visibility: visible;
    }
  }

  svg {
    margin-right: ${({ theme }) => theme.spacing.spacing20};
    width: 27px;
    height: 27px;
  }
`;

const Text = styled.span`
  display: inline-block;
  vertical-align: middle;
  padding-top: ${({ theme }) => theme.spacing.spacing20};
  ${({ theme }) => theme.typography.subTitleMedium};
`;

const GenuineProduct = ({ genuineProductText }: GenuineProductProps) => (
  <ReturnText contentClass="genuineProduct">
    <GenuineProductIcon />
    <Text>100% Genuine Products</Text>
    <ToolTip
      message={genuineProductText}
      contentClass="genuineProduct"
    />
  </ReturnText>
);

export default GenuineProduct;
